import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * cart_language-update operation
 * @param params - Contains path parameters
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const updateCartLanguage = async ({
  params,
  request,
}: {
  params: ApiTypes["cart_language-update"]["parameters"]["path"];
  request: ApiTypes["cart_language-update"]["request"];
}): Promise<ApiTypes["cart_language-update"]["response"]> => {
  try {
    const response = await axiosInstance.patch<
      ApiTypes["cart_language-update"]["response"]
    >(
      `/api/public/v2025-06/commerce/carts/${params.cart_token}/change_language`,
      request,
    );
    return response.data;
  } catch (error) {
    handleApiError(
      error as Error,
      "Failed to updateCartLanguage: ${params.cart_token}",
    );
    throw error;
  }
};
